import Axios from "axios";

export const SelectNome = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/Nome?cat=FA&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "NOME_SELECT", payload: response.data });
    });
  };
};
